// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".input-filter[data-v-b82da4d0]{padding:0 20px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
